/**
 * Dashboard navigation configuration.
 *
 * Consumed by DashboardLayout for both desktop sidebar
 * and mobile slide-over panel.
 */

export interface DashboardNavItem {
  label: string;
  path: string;
  icon: string;
}

export const DASHBOARD_NAV_ITEMS: DashboardNavItem[] = [
  { label: 'Dashboard', path: '/dashboard', icon: 'LayoutDashboard' },
  { label: 'Profile', path: '/dashboard/profile', icon: 'User' },
  { label: 'Community', path: '/dashboard/community', icon: 'Users' },
  { label: 'Events', path: '/dashboard/events', icon: 'Calendar' },
  { label: 'Content', path: '/dashboard/content', icon: 'FileText' },
  { label: 'Analytics', path: '/dashboard/analytics', icon: 'BarChart3' },
  { label: 'Notifications', path: '/dashboard/notifications', icon: 'Bell' },
  { label: 'Settings', path: '/dashboard/settings', icon: 'Settings' },
];
